import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import { fontsStyle } from './fonts';

export default createGlobalStyle`
  html, body {
    height: 100%;
    width: 100%;
  }

  body {
    font-size: 100%;
    font-family: 'Poppins', sans-serif;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
  }

  h1, h2, h3, h4, h5, div, p, button, a, span, section, header, nav, fieldset, body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  fieldset {
    border: none;
  }

  h1, h2, h3, h4, h5, div, p, button, a, span, section, header, nav, input {
    font-size: inherit;
    font-family: 'Poppins', sans-serif;
  }

  > * {
    outline: none;
  }

  ${fontsStyle}
`;
